<script setup lang="ts">
import ProductCounter from '@storefront-satch/components/molecules/product/counter/ProductCounter.vue'
import type {
  LineItemPriceEmits,
  LineItemPriceProps,
} from '@storefront-satch/components/molecules/product/line/types'

const props = defineProps<LineItemPriceProps>()

const emits = defineEmits<LineItemPriceEmits>()

const updateQuantity = async (
  eventName: 'addItem' | 'removeItem' | 'changeCustomQuantityItem',
  quantity: number
) => await emits(eventName, props.line.id, quantity)

const onIncrease = (increaseQuantity: number) =>
  updateQuantity('addItem', increaseQuantity)

const onDecrease = (decreaseQuantity: number) =>
  updateQuantity('removeItem', decreaseQuantity)
</script>

<template>
  <div class="flex items-center justify-between pt-2">
    <div v-if="!canEdit" />
    <ProductCounter
      v-if="canEdit"
      :id="props.line.id"
      :product-name="props.line.variant.product.name"
      :quantity="quantity"
      :is-loading="!!isProcessing"
      :is-error="!!errorMessage"
      @increase="onIncrease"
      @decrease="onDecrease"
      @custom-quantity="updateQuantity('changeCustomQuantityItem', $event)"
    />

    <div
      v-if="
        props.line.cost.totalAmount !==
        (props.line.cost.compareAtAmountPerQuantity ??
          props.line.cost.subtotalAmount)
      "
      class="relative"
    >
      <div
        class="absolute bottom-0 right-0 flex flex-col flex-wrap items-end text-xs"
      >
        <div class="relative font-sans text-black line-through">
          <div class="opacity-70">
            {{
              props.line.cost.compareAtAmountPerQuantityParsed ??
              props.line.cost.subtotalAmountParsed
            }}
          </div>

          <div
            class="font-sans-bold text-red-light absolute left-1/2 top-full -translate-x-1/2"
          >
            {{ props.line.cost.totalAmountParsed }}
          </div>
        </div>
      </div>
    </div>

    <div
      v-else
      class="font-sans-bold bottom-0 right-0 text-xs"
    >
      <div class="text-black">
        {{ props.line.cost.totalAmountParsed }}
      </div>
    </div>
  </div>
</template>
